import {
    getLocalDate, getNumberOfWeeks, getWeekNumber, msInOneDay, msInOneWeek,
} from '../../../youwell-common/dateUtils';
import { hasValue } from '../../../youwell-common/objectUtils';

export const hasErrors = validationErrors => validationErrors !== null && (typeof validationErrors === 'object'
    ? Object.keys(validationErrors).some(key => hasErrors(validationErrors[key]))
    : !!validationErrors);

export const isContactEmpty = contact => contact.name === '';

export const stripEmptyProperties = (obj) => {
    if (!obj) { return null; }

    return Object.keys(obj)
        .filter(key => hasValue(obj[key]))
        .reduce((prev, key) => ({ ...prev, [key]: obj[key] }), {});
};

const modulus = (nr, mod) => ((nr % mod) + mod) % mod; // javascript modulus operator (%) gives negative numbers

export const skillStartHour = 1; // Setting start-time to 01:00 to avoid trouble when jumping from summer to winter-time or vice versa

export const getLocalDateOnlyString = (date) => {
    const d = new Date(date);
    d.setHours(skillStartHour, 0, 0, 0);
    return d.toISOString();
};

export const getMondayInWeek = (date) => {
    const d = new Date(date.getTime() - (modulus(date.getDay() - 1, 7) * msInOneDay));
    d.setHours(skillStartHour, 0, 0, 0);
    return d;
};

export const getSkillWeeks = (skill) => {
    if (!skill?.startTime) {
        return {};
    }
    const startDate = getLocalDate(skill.startTime);
    const monday = getMondayInWeek(startDate);

    const numberOfWeeks = getNumberOfWeeks(skill.startTime, skill.endTime);

    const weekArray = [];
    for (let w = 0; w < numberOfWeeks; w++) {
        const weekStart = new Date(monday.getTime() + (w * msInOneWeek));
        weekArray.push({
            weekStart,
            weekNr: getWeekNumber(weekStart),
        });
    }

    return {
        fromWeek: weekArray[0]?.weekNr,
        toWeek: weekArray[weekArray.length - 1]?.weekNr,
        numberOfWeeks,
        weekArray,
    };
};
